import { ChevronDown } from 'lucide-react';
import React, { useState } from 'react'

interface AccordionWrapperProps {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
  isOpenAtStart?: boolean;
}

export default function AccordionWrapper({ icon, title, children, isOpenAtStart }: AccordionWrapperProps) {
  const [isOpen, setIsOpen] = useState<boolean>(isOpenAtStart || false);
  return (
    <div className={`
    w-full max-w-4xl cursor-pointer border rounded-lg
    ${isOpen ? 'border-transparent' : ''}
    `} onClick={() => setIsOpen(!isOpen)}>
      <div className='flex justify-between items-center p-2'>
        <div className='flex items-center gap-2'>
          {icon}
          <h3 className='hidden md:block'>{title}</h3>
          <h4 className='md:hidden'>{title}</h4>
        </div>

        <ChevronDown
          className={`text-[#225424] transform transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
        />
      </div>
      {
        isOpen && <div className='border-l p-2 ml-4'>
          {children}
          </div>
      }
    </div>
  )
}